import { render, staticRenderFns } from "./SalesTaxGroupEditor.vue?vue&type=template&id=baa6b556&scoped=true"
import script from "./SalesTaxGroupEditor.vue?vue&type=script&lang=js"
export * from "./SalesTaxGroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa6b556",
  null
  
)

export default component.exports